import React, {memo} from 'react'

import {StepTypes} from '../../../../../../../../../types'
import SuggestionSuccessMessage from '../../../../../../../SuggestionSuccessMessage/SuggestionSuccessMessage'
import type {SmartDetectorSuccessProps} from '../SmartDetectors.types'

function CdToWorkingDirSuccess({stepIndex}: SmartDetectorSuccessProps) {
  return (
    <SuggestionSuccessMessage
      stepIndex={stepIndex}
      message={"Great, now you've set the working directory."}
      type={StepTypes.CLI}
    />
  )
}

export default memo<SmartDetectorSuccessProps>(CdToWorkingDirSuccess)
